var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee-wrap",style:({'width':_vm.width})},[_c('div',{ref:"mqBox",staticClass:"marquee-box"},[_c('div',{ref:"mqText",style:({'color': _vm.color})},[_vm._v(_vm._s(_vm.marqueetext))]),_vm._v(" "),_c('div',{style:({'color': _vm.color})},[_vm._v(_vm._s(_vm.marqueetext))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31353705","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/marquee.vue
// module id = null
// module chunks = 